<template>
  <div
    class="scroll_flex_container"
    v-loading="linePayLoading"
    element-loading-text="訂單建立中..."
  >
    <div
      class="column_center_start confirm_page"
      :class="{ keyboard_active: pointInputFocused }"
    >
      <!-- Add By Bryant 2025/08/18 -->
      <div class="row_start_start w-full mt-3">
        <img :src="avatar" class="avatar" v-if="avatar" />
        <div class="column_start_start grow">
          <div class="form_cell">
            <div class="row_center_center label_title">
              <label for="name">Line暱稱</label>
              <text class="must">(必填)</text>
            </div>
            <input
              type="text"
              name="name"
              placeholder="請輸入暱稱"
              v-model="userNameInput"
            />
          </div>
          <div class="form_cell" v-if="shouldShowPhoneField">
            <div class="row_center_center label_title">
              <label :for="phoneFieldName">{{ phoneFieldLabel }}</label>
              <text class="must">(必填)</text>
            </div>
            <input
              type="tel"
              :name="phoneFieldName"
              inputmode="tel"
              :placeholder="phoneFieldPlaceholder"
              v-model="phoneFieldInput"
              :maxlength="phoneFieldMaxLength"
            />
          </div>
        </div>
      </div>
      <!-- Add By Bryant 2025/08/18 End -->
      <!-- 使用新的統一消費模式組件 -->
      <ConsumptionModeInfo
        ref="consumptionModeInfo"
        :consumptionMethod="currentConsumptionMethod"
        :editMode="true"
        :syncInvoiceToMember="true"
      />
      <div class="row_center_between" style="width: 100%; padding: 20px 0 10px">
        <text class="title">商品列表</text>
        <button class="backToOrdering" @click="backToOrdering">繼續選購</button>
      </div>
      <div class="column_center_start" style="width: 100%">
        <ProductConfirm
          v-for="(product, index) in cart"
          :product="product"
          :key="index"
          @deleteProduct="deleteProduct(index)"
        ></ProductConfirm>
      </div>
      <div
        class="row_center_between"
        style="width: 100%; margin: 20px 0; font-size: 18px"
      >
        <text>共{{ getCartQuantity }}項商品</text>
        <div class="row_center_center">
          <text style="font-weight: 600">小計：</text>
          <text class="text-primary-color" style="font-weight: bold"
            >${{ getCartTotalPrice }}</text
          >
        </div>
      </div>
      <!-- 訂單規格 -->
      <div class="w-full column_center_start mb-3" v-if="orderSpecs.length">
        <div
          class="column_center_start w-full"
          v-for="item in orderSpecs"
          :key="item.subSpecID"
        >
          <orderSpec :orderSpec="item" />
        </div>
      </div>
      <div class="column_start_start" style="width: 100%; margin-bottom: 20px">
        <text class="title">訂單備註</text>
        <!--
                <textarea class="order_note" placeholder="輸入訂單備註..." v-model="comment" ref="commentTextarea"
                    @focus="scrollToComment"></textarea>
                -->
        <textarea
          class="order_note"
          placeholder="可輸入訂單備註...例如，取餐地點與時間，或其他商品需求"
          v-model="comment"
          ref="commentTextarea"
          @focus="scrollToComment"
        ></textarea>
      </div>
      <!-- 紅利積分折抵 -->
      <div
        class="column_start_start"
        style="width: 100%; margin: 10px"
        v-if="canUsePoint"
      >
        <text class="title">紅利積分折抵</text>
        <div class="row_center_start" style="margin: 10px 0 15px">
          <text>持有積分：</text>
          <text class="text-primary-color">{{ totalPoints }}</text>
          <text>分</text>
        </div>
        <div class="row_center_start usePoint">
          <input type="checkbox" v-model="usePoint" />
          <text>使用折抵</text>
          <input
            type="number"
            v-model="pointQuantity"
            @focus="scrollToInput"
            @blur="onPointInputBlur"
            ref="pointInput"
            inputmode="numeric"
            min="0"
            step="1"
            placeholder="0"
            :disabled="!usePoint"
          />
          <text>元</text>
        </div>
      </div>
      <!-- TODO: 目前優惠卷尚未完成 先隱藏 -->
      <div
        class="column_start_start coupons_container"
        v-if="memberCouponList.length && false"
      >
        <div class="row_center_start">
          <text class="title">優惠卷({{ memberCouponList.length }})</text>
          <text
            class="text-primary-color"
            style="font-size: 14px; margin-left: 8px"
            v-if="getSelectedCoupon"
            >限用一張，已選擇優惠券</text
          >
        </div>
        <div class="column_center_start coupon_list">
          <Coupon
            style="z-index: 999"
            v-for="(coupon, index) in memberCouponList"
            :key="index"
            :coupon="coupon"
          >
          </Coupon>
        </div>
      </div>
      <!-- 發票選項已整合到 ConsumptionModeInfo 組件中 -->
      <div
        class="column_end_start total_price"
        :style="{ borderTop: displayServiceFee || isDeliveryType }"
      >
        <!-- TODO: 目前積點 & 優惠卷尚未完成 先隱藏 -->
        <div class="row_center_center">
          <text>商品小計：</text>
          <text class="text-primary-color">${{ getCartTotalPrice }}</text>
        </div>
        <div
          class="row_center_center mt-2.5"
          v-if="displayServiceFee && !isDeliveryType"
        >
          <text>服務費：</text>
          <text class="text-primary-color">${{ displayServiceFee }}</text>
        </div>
        <!-- 運費顯示（外送訂單永遠顯示，達到免運門檻時顯示 $0） -->
        <div
          class="row_center_center mt-2.5"
          v-if="isDeliveryType && configuredShippingFee > 0"
        >
          <text>運費：</text>
          <text class="text-primary-color">${{ displayShippingFee }}</text>
          <text
            v-if="freeShipping > 0 && displayShippingFee == 0"
            style="font-size: 14px; color: #4caf50; margin-left: 8px"
          >
            (已達免運門檻)
          </text>
          <text
            v-else-if="freeShipping > 0"
            style="font-size: 14px; color: #999; margin-left: 8px"
          >
            (滿${{ freeShipping }}免運)
          </text>
        </div>
        <div
          class="row_center_center"
          style="margin: 10px 0"
          v-if="isPointUsed && pointQuantity > 0"
        >
          <text>紅利積分折抵：</text>
          <text class="text-primary-color">{{
            usePoint ? "-" + pointQuantity : 0
          }}</text>
        </div>
        <div class="row_center_center" v-if="false">
          <text>優惠卷：</text>
          <text class="text-primary-color">{{
            getSelectedCouponValue ? "-" + getSelectedCouponValue : 0
          }}</text>
        </div>
      </div>
      <div class="row_center_end" style="width: 100%">
        <text class="title" style="font-size: 24px">總金額：</text>
        <text class="title text-primary-color" style="font-size: 24px"
          >${{ displayCartTotalPrice }}</text
        >
      </div>
      <!-- Modify By Bryant 2025/08/22 Begin
            <div class="row_start_start w-full mt-3">
                <img :src="avatar" class="avatar" v-if="avatar" />
                <div class="column_start_start grow">
                    <div class="form_cell">
                        <div class="row_center_center label_title">
                            <label for="name">Line暱稱</label>
                            <text class="must">(必填)</text>
                        </div>
                        <input type="text" name="name" placeholder="請輸入暱稱" v-model="userNameInput" />
                    </div>
            -->
      <!-- Modify By Bryant 2025050801
                    <div class="form_cell">
                        <div class="row_center_center label_title">
                            <label for="name">手機門號</label>
                            <text class="must">(必填)</text>
                        </div>
                    -->
      <!--
                        <input type="tel" name="phone" inputmode="tel" placeholder="請輸入手機門號" v-model="userMobileInput"
                            maxlength="10" />
                        -->
      <!--
                        <input type="tel" name="phone" inputmode="tel" placeholder="請輸入手機門號" v-model="userMobileInput"
                            maxlength="10" />
                    </div>
                    Modify By Bryant 2025050801 End -->
      <!-- Modify By Bryant 2025/08/22 End
                </div>
            </div>
            -->
    </div>
    <SubSummary
      :loading="loading"
      @showSelectPaymentType="showSelectPaymentType"
      @back="backToOrdering"
    ></SubSummary>
    <PaymentTypePopup
      v-if="showPaymentTypePopup && showDiningFrontCheckout"
      :disableLinePay="isZeroAmount"
      :disableJkoPay="isZeroAmount"
      @close="showPaymentTypePopup = false"
      @cashPay="cashPay"
      @linePay="linePay"
      @jkoPay="jkoPay"
    ></PaymentTypePopup>
    <RetailPaymentTypePopup
      v-if="showPaymentTypePopup && showRetailStylePopup"
      :disableLinePay="isZeroAmount"
      :disableJkoPay="isZeroAmount"
      @close="showPaymentTypePopup = false"
      @cashPay="cashPay"
      @linePay="linePay"
      @jkoPay="jkoPay"
    ></RetailPaymentTypePopup>
  </div>
</template>
<script>
import productConfirm from "@/components/store/productConfirm.vue";
import commonUtilities from "@/utils/common.utils";
import coupon from "@/components/coupon/coupon.vue";
import subSummary from "@/components/store/subSummary.vue";
import paymentTypePopup from "@/components/store/paymentTypePopup.vue";
import retailPaymentTypePopup from "@/components/store/retailPaymentTypePopup.vue";
import orderSpec from "@/components/store/orderSpec.vue";
import ConsumptionModeInfo from "@/components/store/ConsumptionModeInfo.vue";
import { mapState, mapGetters } from "vuex";
import config from "@/config";
import { getFrontEndName } from "@/utils/productName.utils";
import jkoPayLogo from "@/assets/jkopay_logo.png";
import jkoPayIcon from "@/assets/jkopay_icon.png";
export default {
  components: {
    ProductConfirm: productConfirm,
    Coupon: coupon,
    SubSummary: subSummary,
    PaymentTypePopup: paymentTypePopup,
    RetailPaymentTypePopup: retailPaymentTypePopup,
    orderSpec: orderSpec,
    ConsumptionModeInfo,
  },
  data() {
    return {
      comment: "",
      usePoint: false,
      pointQuantity: "",
      useCoupon: false,
      CouponValue: 0,
      showPaymentTypePopup: false,
      userNameInput: this.userName,
      userMobileInput: this.userMobile,
      //Add By Bryant 2025/08/25 Begin
      userMobileTailInput: "",
      //Add By Bryant 2025/08/25 End
      userDataChanged: 0,
      loading: true,
      // 結帳驗證進行中（純防連點，不綁畫面）
      isCheckingOut: false,
      linePayLoading: false,
      pointInputFocused: false,
      altImage: "https://images.okshop.tw/linepay_default_pic.png",
    };
  },
  computed: {
    ...mapState("userData", {
      currentStore: "currentStore",
      memberInfo: "memberInfo",
    }),
    ...mapState("basic", {
      storeInfo: "storeInfo",
    }),
    ...mapGetters("coupon", {
      memberCouponList: "memberCouponList",
    }),
    ...mapGetters("userData", {
      storeCode: "storeCode",
      totalPoints: "totalPoints",
      userName: "name",
      userMobile: "phone",
      sPhone: "sPhone",
      telephone: "telephone",
      avatar: "avatar",
    }),
    ...mapGetters("cart", {
      getCartQuantity: "cartQuantity",
      getCartTotalPrice: "cartTotalPrice",
      paymentPrice: "paymentPrice",
      maxPointDiscount: "totalBeforePointDiscount",
      getSelectedCouponValue: "selectedCouponValue",
      areaId: "tableAreaId",
      tableIndex: "tableIndex",
      displayCartTotalPrice: "displayCartTotalPrice",
      serviceFee: "serviceFee",
      displayServiceFee: "displayServiceFee",
      shippingFee: "shippingFee",
      displayShippingFee: "displayShippingFee",
      invoiceTypeIndex: "invoiceTypeIndex",
      invoiceCarrier: "invoiceCarrier",
      invoiceVatNumber: "invoiceVatNumber",
      invoiceNpoBan: "invoiceNpoBan",
    }),
    ...mapGetters("basic", {
      freeShipping: "freeShipping",
      configuredShippingFee: "shippingFee",
      isServiceEnabled: "isServiceEnabled",
      checkoutMode: "checkoutMode",
    }),
    ...mapState("cart", {
      isPointUsed: "isPointUsed",
      cart: "cart",
      getSelectedCoupon: "selectedCoupon",
    }),
    getUrlParameters() {
      return this.$route.params;
    },
    ...mapGetters("userData", {
      isLogin: "isLogin",
      isStoreMember: "isStoreMember",
    }),
    isDelivery() {
      return this.getUrlParameters.method === "delivery";
    },
    isRetailDelivery() {
      return this.getUrlParameters.method === "retailDelivery";
    },
    isDeliveryType() {
      return this.isDelivery || this.isRetailDelivery;
    },
    isPickUp() {
      return this.getUrlParameters.method === "pickUp";
    },
    isRetailPickUp() {
      return this.getUrlParameters.method === "retailPickUp";
    },
    isRetailType() {
      return this.isRetailPickUp || this.isRetailDelivery;
    },
    // 後結帳模式（checkout_mode === 1）
    isAfterCheckout() {
      return this.checkoutMode === 1;
    },
    // 餐飲 + 前結帳：使用 paymentTypePopup
    showDiningFrontCheckout() {
      return !this.isRetailType && !this.isAfterCheckout;
    },
    // 零售 或 餐飲後結帳：使用 retailPaymentTypePopup
    showRetailStylePopup() {
      return this.isRetailType || this.isAfterCheckout;
    },
    isPickUpType() {
      return this.isPickUp || this.isRetailPickUp;
    },
    isDineIn() {
      return this.getUrlParameters.method === "dineIn";
    },
    isTakeOut() {
      return this.getUrlParameters.method === "takeOut";
    },
    consumptionPattern() {
      // (LA) 0: 門市內用
      // (LB) 1: 現場外帶
      // (LC) 2: 預約自取
      // (LD) 3: 店家外送
      // (LE) 4: 零售自取
      // (LF) 5: 零售宅配
      if (this.isRetailDelivery) return 5;
      if (this.isRetailPickUp) return 4;
      if (this.isDelivery) return 3;
      if (this.isPickUp) return 2;
      if (this.isDineIn) return 0;
      if (this.isTakeOut) return 1;
      return 0;
    },
    getPayment() {
      return this.$store.state.cart.payment;
    },
    deliveryDate() {
      return this.getPayment.pickupDate;
    },
    deliveryTime() {
      return this.getPayment.pickupTime;
    },
    deliveryAddress() {
      return this.getPayment.address;
    },
    deliveryPhone() {
      return this.getPayment.phone;
    },
    orderSpecs() {
      return this.$store.state.order.orderSpecs;
    },
    checkUserNameChanged() {
      if (this.userNameInput === this.userName) {
        return false;
      }
      return true;
    },
    checkUserMobileChanged() {
      if (this.userMobileInput === this.userMobile) {
        return false;
      }
      return true;
    },
    shouldUpdateUserMobile() {
      const currentMobile = String(this.userMobile || "").trim();
      return !currentMobile || /^\d{3}$/.test(currentMobile);
    },
    orderNumber() {
      return this.$store.state.order.orderNumber;
    },
    linePayPaymentMethod() {
      return this.$store.getters["payment/linePayPaymentMethod"];
    },
    jkoPayPaymentMethod() {
      return this.$store.getters["payment/jkoPayPaymentMethod"];
    },
    jkoPayPaymentMethodId() {
      return this.$store.getters["payment/jkoPayPaymentMethodId"];
    },
    isCashPaymentEnabled() {
      return this.$store.getters["payment/isCashPaymentEnabled"];
    },
    // 紅利積分折抵：需啟用紅利積分折抵（service_type 12）及紅利積分服務（service_type 3）
    canUsePoint() {
      return this.isServiceEnabled(12) && this.isServiceEnabled(3);
    },
    // 折抵後總金額為 0 時，LINE Pay 無法處理零元交易
    isZeroAmount() {
      return Number(this.displayCartTotalPrice) <= 0;
    },
    paymentUrl() {
      return this.$store.state.payment.paymentUrl;
    },
    // 當前消費模式判斷邏輯
    currentConsumptionMethod() {
      if (this.isRetailDelivery) return "retailDelivery";
      if (this.isRetailPickUp) return "retailPickUp";
      if (this.isDelivery) return "delivery";
      if (this.isPickUp) return "pickUp";
      if (this.isDineIn) return "dineIn";
      if (this.isTakeOut) return "takeOut";
      return "dineIn"; // 預設為內用
    },
    phoneNumberOptionDefaults() {
      return {
        dine_in: "last_three",
        pickup: "full",
        takeout: "last_three",
        delivery: "full",
        retail_pickup: "full",
        retail_delivery: "full",
        table_qr: "last_three",
      };
    },
    phoneNumberOptions() {
      const rawOptions = this.storeInfo?.phone_number_options;
      if (!rawOptions) return this.phoneNumberOptionDefaults;

      try {
        const parsedOptions =
          typeof rawOptions === "string" ? JSON.parse(rawOptions) : rawOptions;
        return {
          ...this.phoneNumberOptionDefaults,
          ...(parsedOptions || {}),
        };
      } catch (error) {
        console.error("解析 phone_number_options 錯誤:", error);
        return this.phoneNumberOptionDefaults;
      }
    },
    phoneNumberOptionKey() {
      if (this.$route.query.orderSource === "tableOrder") return "table_qr";
      if (this.isRetailDelivery) return "retail_delivery";
      if (this.isRetailPickUp) return "retail_pickup";
      if (this.isDelivery) return "delivery";
      if (this.isPickUp) return "pickup";
      if (this.isTakeOut) return "takeout";
      return "dine_in";
    },
    phoneFieldMode() {
      const mode = this.phoneNumberOptions[this.phoneNumberOptionKey];
      return ["last_three", "full", "none"].includes(mode)
        ? mode
        : this.phoneNumberOptionDefaults[this.phoneNumberOptionKey];
    },
    shouldShowPhoneField() {
      return this.phoneFieldMode !== "none";
    },
    phoneFieldName() {
      return this.phoneFieldMode === "full" ? "phone" : "phonetail";
    },
    phoneFieldLabel() {
      return this.phoneFieldMode === "full" ? "手機號碼" : "手機末三碼";
    },
    phoneFieldPlaceholder() {
      return this.phoneFieldMode === "full"
        ? "請輸入手機號碼"
        : "請輸入手機末三碼";
    },
    phoneFieldMaxLength() {
      return this.phoneFieldMode === "full" ? 10 : 3;
    },
    phoneFieldInput: {
      get() {
        return this.phoneFieldMode === "full"
          ? this.userMobileInput
          : this.userMobileTailInput;
      },
      set(value) {
        if (this.phoneFieldMode === "full") {
          this.userMobileInput = value;
          return;
        }
        this.userMobileTailInput = value;
      },
    },
    // 取得會員電話的末三碼（優先順序：mobile_phone → s_phone → phone）
    userMobileTail() {
      try {
        // 第一優先：使用 mobile_phone 的末三碼
        if (this.userMobile && this.userMobile !== "") {
          const phone = String(this.userMobile);
          return phone.slice(-3);
        }
        // 第二優先：使用 s_phone（店家自填電話）的末三碼
        if (this.sPhone && this.sPhone !== "") {
          const phone = String(this.sPhone);
          return phone.slice(-3);
        }
        // 第三優先：使用 telephone（phone 欄位）的末三碼
        if (this.telephone && this.telephone !== "") {
          const phone = String(this.telephone);
          return phone.slice(-3);
        }
        return "";
      } catch (error) {
        console.error("取得手機末三碼錯誤:", error);
        return "";
      }
    },
    // 判斷是否需要更新手機末三碼
    shouldUpdateMobileTail() {
      // 如果 mobile_phone、s_phone、phone 其中任一個有資料，則不需要更新
      return !this.userMobile && !this.sPhone && !this.telephone;
    },
    // 判斷手機末三碼是否有變更
    checkUserMobileTailChanged() {
      return (
        this.userMobileTailInput &&
        this.userMobileTailInput !== "" &&
        this.userMobileTailInput !== this.userMobileTail
      );
    },
  },
  watch: {
    usePoint(val) {
      this.$store.commit("cart/setIsPointUsed", val);
    },
    async cart(val) {
      // 檢查如果購屋車被清空時跳回點餐頁面
      if (val.length == 0) {
        commonUtilities.createToastWithTimer(
          "warning",
          "購物車無商品",
          "",
          2000
        );
        await commonUtilities.delay(2000);
        this.backToOrdering();
      }
    },
    pointQuantity(val) {
      if (val === "") {
        this.$store.commit("cart/setPoints", 0);
        return;
      }

      const numericValue = Number(val);
      const discountLimit = Math.max(
        0,
        Math.floor(Number(this.maxPointDiscount) || 0)
      );
      const availablePoints = Math.max(
        0,
        Math.floor(Number(this.totalPoints) || 0)
      );
      const normalizedValue = Number.isFinite(numericValue)
        ? Math.min(
            Math.max(0, Math.floor(numericValue)),
            discountLimit,
            availablePoints
          )
        : 0;

      if (val !== normalizedValue) {
        this.pointQuantity = normalizedValue;
      }

      console.log("折抵金額", normalizedValue);
      this.$store.commit("cart/setPoints", normalizedValue);
    },
    maxPointDiscount(cap) {
      // 購物車、優惠券或費用變動使上限下降時，同步壓低已輸入的折抵金額
      if (this.pointQuantity > cap) {
        this.pointQuantity = cap;
      }
    },
    deliveryPhone() {
      this.applyDeliveryPhoneFallback();
    },
  },
  async created() {
    try {
      this.linePayLoading = false;
      this.loading = true;
      if (!this.isLogin || !this.isStoreMember) {
        this.$router.replace({
          path: `/${this.storeCode}/store`,
        });
      }
      // 如果購物車沒有商品 退回選擇商品頁
      if (!this.cart.length) this.backToOrdering();
      // 取得商店資訊
      await this.$store.dispatch("basic/fetchStoreInfo");
      // 預先下載街口支付圖示，避免使用者第一次開啟付款彈窗時才觸發下載而延遲顯示
      this.preloadJkoPayImage();
      // 更新會員資料
      await this.$store.dispatch("userData/fetchMemberInfo");
      this.userNameInput = this.userName;
      this.userMobileInput = this.userMobile;
      // 使用 getter 初始化手機末三碼
      this.userMobileTailInput = this.userMobileTail;
      this.applyDeliveryPhoneFallback();
      // 從 store 讀回紅利積分折抵狀態，避免「繼續選購」返回本頁時
      // 元件重新掛載導致 checkbox / 輸入框顯示與 store 折抵狀態不一致
      if (this.isPointUsed && this.$store.state.cart.points > 0) {
        this.pointQuantity = this.$store.state.cart.points;
        this.usePoint = true;
      }

      // 全單規格（sheet_spec_arrangements）為背景載入，
      // 極速結帳時可能尚未回來；未等待會讓 mustHave / 多選設定靜默套用錯誤預設值。
      // 已完成則立即 resolve，不影響正常流程速度；背景載入失敗則在此補打一次，
      // 仍失敗即套用預設值照常結帳（規格選擇影響較小，不阻擋流程）。
      await this.$store.dispatch("spreadsheet/ensureSecondaryMenuData");

      // 自動載入所有全單規格
      this.initializeOrderSpecs();

      // 取得優惠卷列表
      // await this.$store.dispatch('coupon/getMemberCoupons')
      this.loading = false;
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    preloadJkoPayImage() {
      if (!this.jkoPayPaymentMethod) return;

      const image = new Image();
      image.src = this.showRetailStylePopup ? jkoPayIcon : jkoPayLogo;
    },
    initializeOrderSpecs() {
      // 取得所有啟用全單規格的規格
      const specifications = this.$store.getters["spreadsheet/specifications"];
      const productComboSpec =
        this.$store.getters["spreadsheet/productComboSpec"];

      const enabledOrderSpecIDs = specifications
        .filter((spec) => spec.enableForOrderSpec === true)
        .map((spec) => spec.id);

      const nextOrderSpecs = specifications
        .filter((spec) => spec.enableForOrderSpec === true)
        .map((spec) => {
          const existingSpec = this.orderSpecs.find(
            (os) => os.subSpecID === spec.id
          );
          const orderSpecConfig = productComboSpec.find(
            (config) => config.id === spec.id
          );
          const existingCount = existingSpec?.subSpecOptionSelectCount;
          const subSpecOptionSelectCount =
            existingCount?.length === spec.specOptions.length
              ? existingCount
              : spec.specOptions.map(() => 0);

          return {
            subSpecID: spec.id,
            mustHave: orderSpecConfig?.mustHave || false,
            frontEndDisplayName:
              orderSpecConfig?.frontEndDisplayName ||
              getFrontEndName(spec.name),
            isSingleSelection: orderSpecConfig?.isSingleSelection ?? true,
            multiSelectionMin: orderSpecConfig?.multiSelectionMin ?? 0,
            multiSelectionMax: orderSpecConfig?.multiSelectionMax ?? 1,
            allowSelectManyTimes:
              orderSpecConfig?.allowSelectManyTimes || false,
            subSpecOptionSelectCount,
            productSpec: spec,
          };
        });

      if (
        this.orderSpecs.some(
          (spec) => !enabledOrderSpecIDs.includes(spec.subSpecID)
        ) ||
        this.orderSpecs.length !== nextOrderSpecs.length ||
        nextOrderSpecs.length
      ) {
        this.$store.commit("order/setOrderSpecs", nextOrderSpecs);
      }
    },
    applyDeliveryPhoneFallback() {
      if (!this.isDeliveryType || !this.deliveryPhone) return;

      const deliveryPhone = String(this.deliveryPhone).trim();
      if (!deliveryPhone) return;

      if (this.phoneFieldMode === "full" && !this.userMobileInput) {
        this.userMobileInput = deliveryPhone;
        return;
      }

      if (this.phoneFieldMode === "last_three" && !this.userMobileTailInput) {
        this.userMobileTailInput = deliveryPhone.slice(-3);
      }
    },
    async showSelectPaymentType() {
      // 驗證期間不重複觸發（發票驗證需轉打外部光貿服務，最長 8 秒）
      if (this.isCheckingOut) return;
      this.isCheckingOut = true;
      try {
        if (!(await this.validateScheduledTimeBeforeOrder())) return;

        // 先檢查全單規格
        this.orderSpecsValidator();

        // 如果是外送/宅配模式，驗證配送資訊
        if (this.isDeliveryType) {
          const isValid = this.validateDeliveryInfo();
          if (!isValid) {
            return; // 驗證失敗，直接返回
          }
        }

        // 如果是現場外帶模式，驗證內用外帶桌號
        if (this.isTakeOut) {
          const isValid = this.validateTakeOutInfo();
          if (!isValid) {
            return;
          }
        }

        // 驗證發票資訊
        const invoiceValid = await this.validateInvoiceInfo();
        if (!invoiceValid) {
          return; // 驗證失敗，直接返回
        }

        // 檢查是否更新暱稱 & 手機
        if (this.checkUserNameChanged) {
          this.userDataChanged = 1;
          // 更新暱稱
          await this.updateUserName();
        }
        if (
          this.phoneFieldMode === "full" &&
          this.shouldUpdateUserMobile &&
          this.checkUserMobileChanged
        ) {
          this.userDataChanged = 1;
          // 更新手機
          await this.updateUserMobile();
        }
        // Modify By Bryant 2025050801 //
        //                // 檢查手機
        //                if (!this.userMobileInput || this.userMobileInput === '') {
        //                    throw ('請輸入手機門號')
        //                }
        //                // 檢查手機號碼格式
        //                if (!this.$validator.isValidPhoneNumber(this.userMobileInput)) {
        //                    throw ('手機門號格式錯誤')
        //                }
        // Modify By Bryant 2025050801 End //

        // Add By Bryant 2025/08/22 Begin

        this.validatePhoneField();

        // 判斷是否需要更新手機末三碼到後端
        if (
          this.phoneFieldMode === "last_three" &&
          this.shouldUpdateMobileTail &&
          this.checkUserMobileTailChanged
        ) {
          this.userDataChanged = 1;
          // 更新手機末三碼
          await this.updateUserMobileTail();
        }

        // Add By Bryant 2025/08/22 End
      } catch (error) {
        commonUtilities.createToast("error", error?.message || String(error));
        return;
      } finally {
        this.isCheckingOut = false;
      }
      if (
        !this.isCashPaymentEnabled &&
        !this.linePayPaymentMethod &&
        !this.jkoPayPaymentMethod
      ) {
        commonUtilities.createToast("error", "目前無可用付款方式");
        return;
      }
      this.showPaymentTypePopup = true;
    },
    orderSpecsValidator() {
      if (this.orderSpecs.length) {
        for (const orderSpec of this.orderSpecs) {
          const count = orderSpec.subSpecOptionSelectCount.reduce(
            (acc, el) => acc + el,
            0
          );
          // 如果是必選
          if (orderSpec.mustHave && count === 0) {
            throw `${orderSpec.frontEndDisplayName} 尚未選擇`;
          }
          // 如果是單選並且是必選
          if (
            orderSpec.mustHave &&
            orderSpec.isSingleSelection &&
            count !== 1
          ) {
            throw `${orderSpec.frontEndDisplayName} 尚未選擇`;
          }
          // 如果是複選 or 可重複選，加總各項的 quantity 是否符合 minSelect, maxSelect
          if (!orderSpec.isSingleSelection) {
            if (count < orderSpec.multiSelectionMin) {
              throw `${orderSpec.frontEndDisplayName} 尚未選擇`;
            }
            if (count > orderSpec.multiSelectionMax) {
              throw `${orderSpec.frontEndDisplayName} 選擇數量超過最大值`;
            }
          }
        }
      }
    },
    validatePhoneField() {
      if (this.phoneFieldMode === "none") return;

      if (this.phoneFieldMode === "full") {
        if (!this.userMobileInput || this.userMobileInput === "") {
          throw "請輸入手機號碼";
        }
        if (!this.$validator.isValidPhoneNumber(this.userMobileInput)) {
          throw "手機號碼格式錯誤";
        }
        return;
      }

      if (!this.userMobileTailInput || this.userMobileTailInput === "") {
        throw "請輸入手機末三碼";
      }

      if (
        !this.$validator.isValidNumber(this.userMobileTailInput) ||
        String(this.userMobileTailInput).length !== 3
      ) {
        throw "手機末三碼格式錯誤";
      }
    },
    async handleScheduledTimeValidationFailure(
      timeLabel,
      { expired = false } = {}
    ) {
      this.showPaymentTypePopup = false;

      if (expired) {
        this.$store.commit("cart/setPayment", {
          ...this.getPayment,
          pickupTime: "",
        });
      }

      await this.$nextTick();
      await commonUtilities.createAlert(
        "warning",
        expired ? `${timeLabel}已超過` : `請重新選擇${timeLabel}`,
        expired
          ? `您「下單時間」已超過您選擇的「${timeLabel}」，請重新選擇${timeLabel}，以免店家來不及製作餐點。`
          : ""
      );

      const scheduledTimeEditor = this.$refs.consumptionModeInfo?.$el;
      if (scheduledTimeEditor) this.scrollTo(scheduledTimeEditor);
    },
    async validateScheduledTimeBeforeOrder() {
      if (!this.isPickUp && !this.isDelivery) return true;

      const timeLabel = this.isDelivery ? "送達時間" : "取餐時間";

      if (!this.deliveryDate || !this.deliveryTime) {
        await this.handleScheduledTimeValidationFailure(timeLabel);
        return false;
      }

      const dateParts = this.deliveryDate.split("/").map(Number);
      const timeParts = this.deliveryTime.split(":").map(Number);
      const hasInvalidParts =
        dateParts.length !== 3 ||
        timeParts.length !== 2 ||
        [...dateParts, ...timeParts].some(Number.isNaN);
      if (hasInvalidParts) {
        await this.handleScheduledTimeValidationFailure(timeLabel);
        return false;
      }

      const [year, month, day] = dateParts;
      const [hour, minute] = timeParts;
      const scheduledAt = new Date(year, month - 1, day, hour, minute, 0, 0);
      if (Number.isNaN(scheduledAt.getTime())) {
        await this.handleScheduledTimeValidationFailure(timeLabel);
        return false;
      }
      if (Date.now() <= scheduledAt.getTime()) return true;

      await this.handleScheduledTimeValidationFailure(timeLabel, {
        expired: true,
      });
      return false;
    },
    async updateUserName() {
      event.stopPropagation();
      if (this.userNameInput === this.memberInfo.name) {
        return;
      }
      // 檢查暱稱
      if (!this.userNameInput || this.userNameInput === "") {
        throw "請輸入暱稱";
      }
      await this.$store.dispatch("userData/updateMemberInfo", {
        name: this.userNameInput,
      });
    },
    async updateUserMobile() {
      event.stopPropagation();
      if (this.userMobileInput === this.memberInfo.mobile_phone) {
        return;
      }
      // 檢查手機
      if (!this.userMobileInput || this.userMobileInput === "") {
        throw "請輸入手機門號";
      }
      if (!this.$validator.isValidPhoneNumber(this.userMobileInput)) {
        throw "手機門號格式錯誤";
      }
      await this.$store.dispatch("userData/updateMemberInfo", {
        mobile_phone: this.userMobileInput,
      });
    },
    async updateUserMobileTail() {
      event.stopPropagation();

      // 檢查手機末三碼
      if (!this.userMobileTailInput || this.userMobileTailInput === "") {
        throw "請輸入手機末三碼";
      }
      if (!this.$validator.isValidNumber(this.userMobileTailInput)) {
        throw "手機末三碼格式錯誤";
      }

      // 將手機末三碼同時設定到 s_phone 和 phone 欄位
      await this.$store.dispatch("userData/updateMemberInfo", {
        s_phone: this.userMobileTailInput,
        phone: this.userMobileTailInput,
      });
    },
    async cashPay() {
      try {
        if (!(await this.validateScheduledTimeBeforeOrder())) return;

        if (!this.isCashPaymentEnabled) {
          throw new Error("現金付款目前未開放");
        }
        // 如果是外送/宅配模式，檢查是否需要儲存地址
        if (this.isDeliveryType) {
          await this.saveDeliveryAddressIfChecked();
        }

        // 事前驗證：使用紅利積分時，重新取得餘額確認足夠（擋在建立訂單前）
        if (this.isPointUsed && this.pointQuantity > 0) {
          await this.$store.dispatch("userData/fetchMemberInfo");
          if (this.pointQuantity > this.totalPoints) {
            commonUtilities.createToast(
              "error",
              "紅利積分不足，請重新確認折抵金額"
            );
            return;
          }
        }

        if (!(await this.validateScheduledTimeBeforeOrder())) return;

        const paymentType = "cash";
        await this.createOnlineOrder(paymentType);
        // 訂單成立後扣除紅利積分
        if (this.isPointUsed && this.pointQuantity > 0) {
          await this.deductPointsAfterOrder();
        }
        this.toPayment(paymentType);
      } catch (error) {
        console.log("create online order error", error);
        commonUtilities.createToast("error", error.message || "建立訂單失敗");
      }
    },
    async deductPointsAfterOrder() {
      try {
        await this.$store.dispatch("userData/preDeductPoints", {
          orderNumber: this.orderNumber,
          decrease: Number(this.pointQuantity),
          comment: "線上點餐紅利積分折抵",
        });
      } catch (error) {
        // 已於建單前驗證餘額，殘餘失敗機率極低；僅記錄，仍照常導向付款頁
        console.error("紅利積分扣點失敗", error);
      }
    },
    async linePay() {
      try {
        if (this.isZeroAmount) {
          commonUtilities.createToast(
            "error",
            "金額為 0 元，無法使用 LINE Pay 付款"
          );
          return;
        }

        if (!(await this.validateScheduledTimeBeforeOrder())) return;

        // 如果是外送/宅配模式，檢查是否需要儲存地址
        if (this.isDeliveryType) {
          await this.saveDeliveryAddressIfChecked();
        }

        // 事前驗證：使用紅利積分時，重新取得餘額確認足夠（擋在建立訂單前）
        if (this.isPointUsed && this.pointQuantity > 0) {
          await this.$store.dispatch("userData/fetchMemberInfo");
          if (this.pointQuantity > this.totalPoints) {
            commonUtilities.createToast(
              "error",
              "紅利積分不足，請重新確認折抵金額"
            );
            return;
          }
        }

        if (!(await this.validateScheduledTimeBeforeOrder())) return;

        const paymentType = "linePay";
        this.linePayLoading = true;
        await this.createOnlineOrder(paymentType);
        // 訂單成立後扣除紅利積分
        if (this.isPointUsed && this.pointQuantity > 0) {
          await this.deductPointsAfterOrder();
        }
        // linePay 建立訂單後要使用 linePay 支付結帳
        await this.createLinePayRequest();
        console.log("paymentUrl", this.paymentUrl);
        if (this.paymentUrl) {
          window.location.href = this.paymentUrl;
        }
      } catch (error) {
        console.log("create online order error", error);
        commonUtilities.createToast("error", error.message || "建立訂單失敗");
      } finally {
        this.linePayLoading = false;
      }
    },
    // 街口支付：建單後呼叫 Entry 取得付款網址
    async jkoPay() {
      try {
        if (this.isZeroAmount) {
          commonUtilities.createToast(
            "error",
            "金額為 0 元，無法使用街口支付付款"
          );
          return;
        }

        if (!(await this.validateScheduledTimeBeforeOrder())) return;

        if (!this.jkoPayPaymentMethodId) {
          commonUtilities.createToast("error", "街口支付設定異常，請聯繫門市");
          return;
        }

        if (this.isDeliveryType) {
          await this.saveDeliveryAddressIfChecked();
        }

        if (this.isPointUsed && this.pointQuantity > 0) {
          await this.$store.dispatch("userData/fetchMemberInfo");
          if (this.pointQuantity > this.totalPoints) {
            commonUtilities.createToast(
              "error",
              "紅利積分不足，請重新確認折抵金額"
            );
            return;
          }
        }

        const paymentType = "jkoPay";
        this.linePayLoading = true;
        await this.createOnlineOrder(paymentType);
        if (this.isPointUsed && this.pointQuantity > 0) {
          await this.deductPointsAfterOrder();
        }
        await this.createJkoPayEntry();
        console.log("paymentUrl", this.paymentUrl);
        if (this.paymentUrl) {
          window.location.href = this.paymentUrl;
        }
      } catch (error) {
        console.log("jkopay entry error", error);
        commonUtilities.createToast("error", error.message || "建立訂單失敗");
      } finally {
        this.linePayLoading = false;
      }
    },
    async createJkoPayEntry() {
      // 每次從確認頁發起付款都是一次新的付款嘗試
      const attemptUuid = commonUtilities.generateUUID();
      this.$store.commit("payment/setJkoPayAttemptUuid", attemptUuid);

      // 同一台電腦進行本機付款測試時，讓街口導回本機開發伺服器。
      // 其他環境仍沿用設定檔網址，不影響測試站、正式站與 LINE Pay。
      const isLocalDevelopment = ["localhost", "127.0.0.1"].includes(
        window.location.hostname
      );
      const resultDisplayBaseUrl = isLocalDevelopment
        ? "http://localhost:8080"
        : config.redirectUri;

      // 返回頁帶 attempt_uuid，避免手機從街口 App 回來開新分頁時遺失冪等鍵
      const resultDisplayUrl = `${resultDisplayBaseUrl}${this.toPaymentPagePath(
        "jkoPay",
        { attempt_uuid: attemptUuid }
      )}`;

      await this.$store.dispatch("payment/jkoPayEntry", {
        store_payment_methods_config_id: this.jkoPayPaymentMethodId,
        attempt_uuid: attemptUuid,
        order_number: this.orderNumber,
        result_display_url: resultDisplayUrl,
        final_price: Number(this.displayCartTotalPrice),
      });
    },
    async saveDeliveryAddressIfChecked() {
      try {
        const consumptionModeInfo = this.$refs.consumptionModeInfo;
        if (!consumptionModeInfo) return;

        // 呼叫 ConsumptionModeInfo 的方法，進而呼叫 deliveryEdit 的 saveIfChecked
        await consumptionModeInfo.saveDeliveryAddressIfChecked();

        // 儲存成功後，重新取得會員資料
        await this.$store.dispatch("userData/fetchMemberInfo");
      } catch (error) {
        console.error("儲存地址失敗:", error);
        throw error;
      }
    },
    async createLinePayRequest() {
      const productsInfo = this.cart.map((product) => {
        const imageUrl = this.$store.getters["product/getProductImageById"](
          product.product.id
        );

        return {
          id: product.product.id,
          name: getFrontEndName(product.product.name),
          imageUrl: imageUrl || this.altImage,
          quantity: product.quantity,
          price: Number(this.$store.getters["cart/productUnitPrice"](product)),
        };
      });

      // 建立額外費用列表（服務費、運費等）
      const additionalFees = [];

      // 服務費當成一個商品 避免 order_amount 和 products_info 加總金額不一致
      if (this.displayServiceFee > 0) {
        additionalFees.push({
          id: "serviceFee",
          name: "服務費",
          imageUrl: "",
          quantity: 1,
          price: Number(this.displayServiceFee),
        });
      }

      // 運費當成一個商品（僅外送模式）
      if (this.displayShippingFee > 0) {
        additionalFees.push({
          id: "shippingFee",
          name: "運費",
          imageUrl: "",
          quantity: 1,
          price: Number(this.displayShippingFee),
        });
      }

      // 紅利積分折抵列入商品明細，使明細加總與 LINE Pay 請款金額一致
      if (this.isPointUsed && this.pointQuantity > 0) {
        additionalFees.push({
          id: "pointDiscount",
          name: "紅利積分折抵",
          imageUrl: "",
          quantity: 1,
          price: -Number(this.pointQuantity),
        });
      }

      const sendData = {
        order_number: this.orderNumber,
        store_payment_methods_config_id:
          this.linePayPaymentMethod.store_payment_methods_config_id,
        order_amount: this.displayCartTotalPrice,
        confirm_url: `${config.redirectUri}${this.toPaymentPagePath(
          "linePay"
        )}`,
        cancel_url: `${config.redirectUri}${this.toPaymentPagePath("linePay")}`,
        products_info: [...productsInfo, ...additionalFees],
      };
      await this.$store.dispatch("payment/linePayRequest", sendData);
    },
    // 剔除 LINE Pay 單次交易憑證，避免舊 transactionId/orderId
    // 污染下一筆付款（重新支付會建立新訂單，不可沿用舊憑證）
    getCleanQuery() {
      const query = { ...this.$route.query };
      delete query.transactionId;
      delete query.orderId;
      delete query.attempt_uuid;
      return query;
    },
    toPaymentPagePath(paymentType, extraQuery = {}) {
      const process = "orderPayment";
      const { store, method } = this.getUrlParameters;
      let path = `/${store}/${process}/${method}/${this.areaId}/${this.tableIndex}/${paymentType}/${this.orderNumber}`;
      const query = new URLSearchParams({
        ...this.getCleanQuery(),
        ...extraQuery,
      }).toString();
      return query ? `${path}?${query}` : path;
    },
    toPayment(paymentType) {
      const path = this.toPaymentPagePath(paymentType);
      this.$router.push(path);
    },
    async createOnlineOrder(paymentType) {
      try {
        commonUtilities.createLoading("訂單建立中", "請稍後");
        let payment = JSON.parse(JSON.stringify(this.getPayment));

        // 從 Vuex store 讀取發票資料
        const invoiceTypeIndex = this.invoiceTypeIndex ?? 0;
        const invoiceTypeNames = ["紙本發票", "手機載具", "統一編號", "愛心碼"];

        // 根據發票類型索引決定發票號碼
        let invoiceNumber = null;
        if (invoiceTypeIndex === 0) {
          // 紙本發票：不設定發票號碼
          invoiceNumber = null;
        } else if (invoiceTypeIndex === 1) {
          invoiceNumber = this.invoiceCarrier;
        } else if (invoiceTypeIndex === 2) {
          invoiceNumber = this.invoiceVatNumber;
        } else if (invoiceTypeIndex === 3) {
          invoiceNumber = this.invoiceNpoBan;
        }

        // 保持向後相容的 invoiceType 物件結構
        const invoiceType = {
          type: invoiceTypeNames[invoiceTypeIndex],
          invoiceNumber: invoiceNumber,
        };

        payment.paymentType = paymentType;
        payment.pointQuantity = this.isPointUsed ? this.pointQuantity : 0;
        payment.comment = this.comment;
        payment.couponTotalValue = this.getSelectedCouponValue;
        payment.usedCoupon = this.$store.getters["cart/selectedCoupons"];
        payment.cart = this.cart;
        payment.serviceFee = this.serviceFee;
        payment.displayServiceFee = this.displayServiceFee;
        payment.shippingFee = this.shippingFee;
        payment.displayShippingFee = this.displayShippingFee;
        payment.paymentPrice = this.displayCartTotalPrice;
        payment.totalPrice = this.getCartTotalPrice;
        payment.invoiceType = invoiceType;
        payment.consumptionPattern = this.consumptionPattern;
        if (this.isRetailPickUp) {
          payment.pickupTime = null;
        }
        //Add By Bryant 2025/08/25 Begin
        payment.userMobileTail =
          this.phoneFieldMode === "none" ? null : this.phoneFieldInput;
        //Add By Bryant 2025/08/25 End
        // 統一編號來自 payment.vatNumber（由 deliveryEdit 組件設定）
        payment.buyerTaxId = this.getPayment.vatNumber || null;

        // 用戶資料是否有更新
        payment.userDataChanged = this.userDataChanged;
        // 用戶輸入匡的暱稱
        payment.userName = this.userNameInput;
        // 用戶輸入匡的手機
        payment.userMobile = this.userMobileInput;
        await this.$store.commit("cart/setPayment", payment);
        await this.$store.dispatch("order/createOnlineOrder");
        commonUtilities.closeLoading();
        await commonUtilities.delay(300);
      } catch (error) {
        commonUtilities.createToast("error", "訂單建立失敗", `${error}`);
        throw error;
      }
    },
    scrollToInput() {
      // focus 時才加大底部留白，讓 input 有空間捲到鍵盤上方（blur 後還原，避免空白）
      this.pointInputFocused = true;
      // 等鍵盤滑上來（約 300ms）再捲動，避免可視高度尚未被壓縮造成位置誤差
      setTimeout(() => {
        this.$refs.pointInput?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 300);
    },
    onPointInputBlur() {
      this.pointInputFocused = false;
    },
    scrollToComment() {
      const commentTextarea = this.$refs.commentTextarea;
      this.scrollTo(commentTextarea);
    },
    scrollTo(el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    },
    backToOrdering() {
      this.pointQuantity = "";
      this.usePoint = false;
      this.$store.commit("cart/setPoints", 0);
      this.$store.commit("cart/setIsPointUsed", false);

      const { store, method, areaId, tableIndex } = this.getUrlParameters;
      this.$router.push({
        path: `/${store}/ordering/${method}/${areaId}/${tableIndex}`,
        query: this.$route.query,
      });
    },
    deleteProduct(index) {
      let cart = JSON.parse(JSON.stringify(this.cart));
      cart.splice(index, 1);
      this.$store.commit("cart/setCart", cart);
    },
    // 驗證外送資訊
    validateDeliveryInfo() {
      const consumptionModeInfo = this.$refs.consumptionModeInfo;
      if (!consumptionModeInfo) {
        commonUtilities.createToast("error", "無法取得外送資訊組件");
        return false;
      }

      // 呼叫 ConsumptionModeInfo 的驗證方法
      return consumptionModeInfo.validateDeliveryInfo();
    },
    // 驗證現場外帶資訊
    validateTakeOutInfo() {
      const consumptionModeInfo = this.$refs.consumptionModeInfo;
      if (!consumptionModeInfo) {
        commonUtilities.createToast("error", "無法取得消費模式資訊組件");
        return false;
      }

      return consumptionModeInfo.validateTakeOutInfo();
    },
    // 驗證發票資訊
    async validateInvoiceInfo() {
      const consumptionModeInfo = this.$refs.consumptionModeInfo;
      if (!consumptionModeInfo) {
        commonUtilities.createToast("error", "無法取得消費模式資訊組件");
        return false;
      }

      // 取得 InvoiceSelector 的 ref（透過 ConsumptionModeInfo）
      const invoiceSelectorRef = consumptionModeInfo.$refs.invoiceSelectorRef;
      if (!invoiceSelectorRef) {
        // 如果沒有 InvoiceSelector（發票功能未啟用），直接通過
        return true;
      }

      // 只有真的要轉打光貿時才顯示等待中狀態，
      // 其餘路徑（非光貿／紙本／統編／已驗過）維持畫面不變
      const needsWait = invoiceSelectorRef.needsRemoteValidation();
      if (needsWait) this.loading = true;

      let isValid;
      try {
        isValid = await invoiceSelectorRef.validate();
      } finally {
        if (needsWait) this.loading = false;
      }

      if (!isValid) {
        if (invoiceSelectorRef.errorMessage) {
          commonUtilities.createToast("error", invoiceSelectorRef.errorMessage);
        }
        return false;
      }

      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.confirm_page {
  width: 100%;
  padding: 0 5%;
  flex-grow: 1;
  font-size: 16px;
  font-weight: 400;
  font-family: PingFang SC;
  padding-bottom: 50px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
}

.confirm_page.keyboard_active {
  padding-bottom: 300px;
}

.backToOrdering {
  width: 80px;
  height: 36px;
  border: none;
  border-radius: 30px;
  color: #000;
  font-size: 14px;
  background-color: #eeeeee;
}

.order_note {
  width: 100%;
  padding: 15px 5%;
  height: 90px;
  border: 1px solid #dddddd;
  border-radius: 12px;
  margin-top: 10px;
  font-size: 18px;
}

.usePoint {
  font-size: 16px;

  input[type="checkbox"] {
    width: 22px;
    height: 22px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid #dddddd;
    border-radius: 6px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input:checked {
    color: black;
    background-color: #fbcb02;
    border-color: #fbcb02;
  }

  input:checked::before {
    content: "\2714";
    font-size: 16px;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input[type="number"] {
    width: 64px;
    height: 36px;
    border: 1px solid #dddddd;
    border-radius: 8px;
    margin: 0 8px;
    text-align: center;
    font-size: 18px;
  }

  input[type="number"]:focus::placeholder {
    color: transparent;
  }
}

.tabs {
  flex-shrink: 0;
  margin: 20px 0;

  button {
    flex-shrink: 0;
    border-radius: 30px;
    background-color: #dddddd;
    color: #000;
    border: none;
    height: 44px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    font-size: 16px;
    line-height: 0;
    border-radius: 0;
    margin: 0 1px;
  }

  button:nth-child(1) {
    border-radius: 8px 0 0 8px;
  }

  button:last-child {
    border-radius: 0 8px 8px 0;
  }

  .tabed {
    color: #000;
    background-color: #fbcb02;
    flex-shrink: 0;
  }
}

.total_price {
  width: 100%;
  margin: 0 0 20px;
  padding: 20px 0;
  border-top: 1px dotted #000;
  border-bottom: 1px dotted #000;
  font-size: 18px;
}

.coupons_container {
  -ms-overflow-style: none;
  scrollbar-width: none;
  height: 360px;
  width: 100%;
  margin-bottom: 20px;
}

.coupons_container ::-webkit-scrollbar {
  display: none;
}

.coupon_list {
  width: 100%;
  margin-top: 15px;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 30px;
  --scrollbar-width: 0px;
  --mask-height: 100px;
  --mask-image-content: linear-gradient(
    to bottom,
    black,
    black var(--mask-height),
    black calc(100% - var(--mask-height)),
    transparent
  );
  --mask-size-content: calc(100% - var(--scrollbar-width)) 100%;
  --mask-image-scrollbar: linear-gradient(black, black);
  --mask-size-scrollbar: var(--scrollbar-width) 100%;
  mask-image: var(--mask-image-content), var(--mask-image-scrollbar);
  mask-size: var(--mask-size-content), var(--mask-size-scrollbar);
  mask-position: 0 100%, 100% 100%;
  mask-repeat: no-repeat, no-repeat;
}

.invoice_input {
  background-color: #fff;
  flex-grow: 1;
  height: 44px;
  border: none;
  font-size: 18px;
  color: #000;

  input {
    border: none;
    border: 1px solid #dddddd;
    border-radius: 6px;
    padding: 0 10px;
    height: 100%;
  }

  // input:focus {
  //     outline: none;
  //     border: none;
  //     -webkit-appearance: none;
  //     /* 针对部分 WebKit 内核的浏览器，如 Chrome 和 Safari */

  // }
}

.form_cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  margin-bottom: 15px;
  font-size: 16px;
  color: #000;
  font-weight: 400;

  input {
    width: 100%;
    height: 44px;
    border: none;
    background-color: #fff;
    font-size: 18px;
    color: #000;
    border-radius: 6px;
    padding: 0 10px;
    margin-top: 6px;
    border: 1px solid #dddddd;
  }

  ::placeholder {
    color: rgba($color: #000000, $alpha: 0.3);
  }
}

.label_title {
  font-weight: 500;
  font-size: 16px;
  font-family: PingFang SC;
  margin-bottom: 5px;

  .must {
    color: #c0462e;
    letter-spacing: 1px;
    margin-left: 4px;
  }
}

.avatar {
  margin-right: 10px;
  width: 86px;
  height: 86px;
  border-radius: 50%;
  border: 3px solid #facb00;
  flex-shrink: 0;
}
</style>
